import React from 'react';

import Navigation from '../components/static/Navigation';
import Footer from '../components/static/Footer';

class Error404Page extends React.Component {
    constructor() {
        super();
    }

    render() {
        return <div className='w-full p-0'>
            <Navigation />

            <div className='bg-white'>
                <div className='container'>
                    <h2 className='neutral-charcoal text-center font-bold' style={{marginTop: '120px', marginBottom: '120px'}}>404</h2>
                    
                    <p className='neutral-charcoal fs-3 font-medium mt-12 text-center'>Sidan kunde inte hittas.</p>
                    <p className='neutral-charcoal fs-4 font-medium text-center'>Du kan försöka hitta det du letar efter i menyn ovan.</p>
                    <p className='neutral-charcoal fs-4 font-medium text-center' style={{marginBottom: '120px'}}>Om du istället vill mejla oss kan du <a className='supp-spruce' href="mailto:information@treebula.se"><u>klicka här</u></a>.</p>
                </div>
            </div>

            <Footer />
        </div>
    }
}

export default Error404Page;